/* tslint:disable */
/* eslint-disable */
/**
 * MachineGo P1 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MachineCommissionViewModel
 */
export interface MachineCommissionViewModel {
    /**
     * 
     * @type {number}
     * @memberof MachineCommissionViewModel
     */
    categoryId?: number;
    /**
     * 
     * @type {number}
     * @memberof MachineCommissionViewModel
     */
    subCategoryId?: number;
    /**
     * 
     * @type {number}
     * @memberof MachineCommissionViewModel
     */
    hourlyRate?: number;
    /**
     * 
     * @type {number}
     * @memberof MachineCommissionViewModel
     */
    dailyRate?: number;
    /**
     * 
     * @type {number}
     * @memberof MachineCommissionViewModel
     */
    monthlyRate?: number;
    /**
     * 
     * @type {number}
     * @memberof MachineCommissionViewModel
     */
    yearlyRate?: number;
}

export function MachineCommissionViewModelFromJSON(json: any): MachineCommissionViewModel {
    return MachineCommissionViewModelFromJSONTyped(json, false);
}

export function MachineCommissionViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): MachineCommissionViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'categoryId': !exists(json, 'categoryId') ? undefined : json['categoryId'],
        'subCategoryId': !exists(json, 'subCategoryId') ? undefined : json['subCategoryId'],
        'hourlyRate': !exists(json, 'hourlyRate') ? undefined : json['hourlyRate'],
        'dailyRate': !exists(json, 'dailyRate') ? undefined : json['dailyRate'],
        'monthlyRate': !exists(json, 'monthlyRate') ? undefined : json['monthlyRate'],
        'yearlyRate': !exists(json, 'yearlyRate') ? undefined : json['yearlyRate'],
    };
}

export function MachineCommissionViewModelToJSON(value?: MachineCommissionViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'categoryId': value.categoryId,
        'subCategoryId': value.subCategoryId,
        'hourlyRate': value.hourlyRate,
        'dailyRate': value.dailyRate,
        'monthlyRate': value.monthlyRate,
        'yearlyRate': value.yearlyRate,
    };
}

